<template>
    <div id="pad-wrapper" class="animation-duration">
        <div class="row head">
            <div class="col-md-9">
                <h4>Статистика</h4>
            </div>
            <div class="col-md-3">

            </div>
        </div>

        <div class="row">
            <div class="col-md-12">
                <v-card flat>
                    <v-card-text>
                        <div class="block mydatepicker mt-4 mr-4">
                            <el-input placeholder="Поиск.." v-model="search" class="mysearch"></el-input>
                            <el-date-picker
                                    v-model="rangeDates"
                                    type="daterange"
                                    align="right"
                                    range-separator="-"
                                    start-placeholder="Начало"
                                    end-placeholder="Конец"
                                    @change="changeDates"
                                    :picker-options="pickerOptions2"
                                    class="ml-2">
                            </el-date-picker>
                            <el-button class="ml-2" @click="changeDates" style="padding-top: 9px; padding-bottom: 5px;">
                                <v-icon size="24">refresh</v-icon>
                            </el-button>
                        </div>
                        <h4>Сайты</h4>
                        <v-data-table
                                :headers="headers_sites"
                                :items="filteredSites"
                                :loading="isLoadingSites"
                                multi-sort
                                loading-text="Загрузка..."
                        >
                            <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
                            <template slot="no-data">
                                <div v-show="!isLoadingSites">
                                    Нет сайтов
                                </div>
                            </template>
                            <template v-slot:item.phones="{ item }">
                                {{ item.phones }} <span v-if="item.phones > 0">({{myPercent(item.phones,item.visits)}}%)</span>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters,mapActions} from 'vuex'
    export default {
        data() {
            return {
                search: '',
                isLoadingSites: false,
                rangeDates: [],
                mytime: 'Сегодня',
                headers_sites: [
                    {
                        text: 'Id',
                        align: 'left',
                        sortable: true,
                        value: 'id'
                    },
                    {
                        text: 'Наименование',
                        align: 'left',
                        sortable: true,
                        value: 'title'
                    },
                    {
                        text: 'Визитов',
                        align: 'left',
                        sortable: true,
                        value: 'visits'
                    },
                    {
                        text: 'Номеров',
                        align: 'left',
                        sortable: true,
                        value: 'phones'
                    }
                ],
                pickerOptions2: {
                    shortcuts: [
                        {
                            text: 'Сегодня',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                picker.$emit('pick', [start, end]);
                            }
                        },
                        {
                            text: 'Вчера',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                end.setTime(end.getTime() - 3600 * 1000 * 24);
                                start.setTime(start.getTime() - 3600 * 1000 * 24);
                                picker.$emit('pick', [start, end]);
                            }
                        },
                        {
                            text: 'Неделя',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                                picker.$emit('pick', [start, end]);
                            }
                        },
                        {
                            text: 'Месяц',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                                picker.$emit('pick', [start, end]);
                            }
                        },
                        {
                            text: '3 месяца',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                                picker.$emit('pick', [start, end]);
                            }
                        },
                        {
                            text: 'Пол года',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                                picker.$emit('pick', [start, end]);
                            }
                        },
                        {
                            text: 'Год',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                                picker.$emit('pick', [start, end]);
                            }
                        }
                    ],
                    firstDayOfWeek: 1
                },
            }
        },
        computed: {
            filteredSites()
            {
                return this.statsites.filter(site => {
                    if (site.title) {
                        return site.title.toLowerCase().indexOf(this.search.toLowerCase()) > -1
                    }
                    return true
                })
            },
            ...mapGetters('Sites', {
                statsites: 'GET_STATSITES',
            }),
        },
        mounted() {
            let start = new Date()
            let end = new Date()
            this.rangeDates = [start,end]
            this.changeDates()
        },
        methods: {
            ...mapActions('Sites', {
                loadStatSites: 'loadStatSites',
            }),
            changeDates() {
                if (this.rangeDates !== null)
                {
                    this.datesUrl = 'start='+this.$moment(String(this.rangeDates[0])).format('YYYY-MM-DD')+'&end='+this.$moment(String(this.rangeDates[1])).format('YYYY-MM-DD')
                    let now = new Date()
                    if (this.$moment(String(now)).format('YYYY-MM-DD') == this.$moment(String(this.rangeDates[0])).format('YYYY-MM-DD') && this.$moment(String(now)).format('YYYY-MM-DD') == this.$moment(String(this.rangeDates[1])).format('YYYY-MM-DD')) {
                        this.mytime = 'Сегодня'
                    } else {
                        this.mytime = this.$moment(String(this.rangeDates[0])).format('YYYY-MM-DD') + ' - ' + this.$moment(String(this.rangeDates[1])).format('YYYY-MM-DD')
                    }

                    this.isLoadingSites = true
                    this.loadStatSites(this.datesUrl)
                        .then(() => {
                            this.isLoadingSites = false
                        })
                        .catch(() => {
                            this.isLoadingSites = false
                        })
                }
            },
            myPercent(a,b) {
                if (b == 0) return 0
                return Math.round(a*10000/b)/100
            }
        }
    }
</script>

<style scoped>
.mysearch {
    width: 300px;
    display: inline-block;
}
</style>